import styled from '@emotion/styled';
import { Container as RootContainer } from '@presentation/components';
import { BREAKPOINTS, mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Container = styled(RootContainer)`
  margin-top: 120px;
  padding-left: 100px;
  padding-right: 100px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    margin-top: 60px;
    padding-left: 60px;
    padding-right: 60px;
  }

  ${mediaQuery(BREAKPOINTS.phone)} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const SpaceTop = styled.div`
  margin-top: 120px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    margin-top: 60px;
  }
`;

export const Title = styled.h2<{ centered?: string; color?: 'purple' | 'blue' | 'light' }>`
  color: ${(props) =>
    props.color ? props.theme.color[props.color].default : props.theme.color.dark.shade};
  font-family: ${(props) => props.theme.font.alternate};
  ${(props) => props.centered === 'true' && 'text-align: center;'};
  ${responsiveFontSize(42, 1)};
`;
export const Paragraph = styled.p`
  color: ${(props) => props.theme.color.light.default};
`;
